var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M13.9722 20.4861C16.2315 21.4954 18.5185 22 20.8333 22C21.1667 22 21.4444 21.8889 21.6667 21.6667C21.8889 21.4444 22 21.1667 22 20.8333V16.3333C22 16.0926 21.9167 15.875 21.75 15.6806C21.5833 15.4861 21.3704 15.3519 21.1111 15.2778L17.2778 14.5C17.0185 14.463 16.7546 14.4861 16.4861 14.5694C16.2176 14.6528 16 14.7778 15.8333 14.9444L13.2222 17.5556C12.5185 17.1482 11.8519 16.6991 11.2222 16.2083C10.5926 15.7176 9.99074 15.1852 9.41667 14.6111C8.80556 14.0185 8.24537 13.4028 7.73611 12.7639C7.22685 12.125 6.78704 11.463 6.41667 10.7778L9.11111 8.05556C9.25926 7.90741 9.36111 7.73148 9.41667 7.52778C9.47222 7.32407 9.48148 7.07408 9.44445 6.77778L8.72222 2.88889C8.68519 2.64815 8.56482 2.43981 8.36111 2.26389C8.15741 2.08796 7.92593 2 7.66667 2H3.16667C2.83333 2 2.55556 2.11111 2.33333 2.33333C2.11111 2.55556 2 2.83333 2 3.16667C2 5.48148 2.50463 7.76852 3.51389 10.0278C4.52315 12.287 5.9537 14.3426 7.80556 16.1944C9.65741 18.0463 11.713 19.4769 13.9722 20.4861Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1576E1"
  }))));
};
export default SvgPhone;